module.exports = {
    'Log in': 'Connectez-vous',
    'You must be an <span>XXL</span> member': 'Vous devez être membre <span>XXL</span>',
    'You must be an XXL member': 'Vous devez être membre XXL',
    'to watch full video.': 'pour regarder la vidéo en entier.',
    'to open this photo.': 'pour ouvrir cette photo.',
    'to post a comment': 'pour ajouter un commentaire.',
    'Become an XXL member': 'Devenez membre XXL',

    "Loading...": "En cours de chargement...",
    "This post is now hidden.": "Ce post est masqué car il est contraire aux CGU de BobTV.",
    "%1, location: <strong>%2</strong>": "Le %1, localisation : <strong>%2</strong>",
    "Like": "J’aime",
    "Liked": "J’aime",
    "Denounce": "Denoncer",
    "Denounced": "Dénoncé",
    "Denounce this post if it is offensive or contrary to the Terms of BobTV.": "Dénoncez ce post s'il est choquant ou contraire aux CGU de BobTV.",
    "Comments": "Commentaires",
    "Enter your message": "Ajouter un commentaire",
    "Sending...": "En cours d’envoi...",
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/wall_material.js